import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const UPGRADE_URL = 'https://lp.scalizai.com'; // URL atualizada

interface UpgradeButtonProps {
  text?: string;
}

const UpgradeButton: React.FC<UpgradeButtonProps> = ({ text }) => {
  const { t } = useTranslation();
  
  return (
    <motion.a
      href={UPGRADE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="flex h-10 w-full cursor-pointer items-center justify-center overflow-hidden rounded-lg bg-primary text-white gap-2 text-sm font-bold leading-normal tracking-[0.015em] px-4 hover:opacity-90 transition-opacity"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      {text || t('Fazer Upgrade para PRO')}
      <ArrowRight className="size-4" />
    </motion.a>
  );
};

export default UpgradeButton;